import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import * as bootstrapUtils from 'react-bootstrap/lib/utils/bootstrapUtils';
import { Button } from 'react-bootstrap';

import SecureRoute from './ui/SecureRoute';

import Login from './routes/login/Login';
import Assets from './routes/assets/Assets';
import Files from './routes/files/Files';
import Tags from './routes/tags/Tags';

bootstrapUtils.addStyle(Button, 'hollow-primary');
bootstrapUtils.addStyle(Button, 'hollow-success');
bootstrapUtils.addStyle(Button, 'hollow-danger');
bootstrapUtils.addStyle(Button, 'hollow-info');

export default () => (
  <Router>
    <div>
      <Switch>
        <SecureRoute exact path="/" component={Assets} />
        <SecureRoute path="/pages" component={Assets} />
        <SecureRoute path="/files" component={Files} />
        <SecureRoute path="/tags" component={Tags} />
        <Route path="/login" component={Login} />
      </Switch>
    </div>
  </Router>
);



// WEBPACK FOOTER //
// ./src/components/App.js